import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const PermissionGuard = ({ 
  children, 
  requiredPermission = null, 
  requiredSection = null, 
  requiredAction = null,
  fallback = null 
}) => {
  const { 
    checkPermission, 
    checkViewPermission, 
    checkCreatePermission, 
    checkUpdatePermission, 
    checkDeletePermission 
  } = useAuth();

  // Check specific permission if provided
  if (requiredPermission) {
    if (!checkPermission(requiredPermission)) {
      return fallback;
    }
  }

  // Check section and action permissions if provided
  if (requiredSection && requiredAction) {
    let hasAccess = false;
    
    switch (requiredAction) {
      case 'view':
        hasAccess = checkViewPermission(requiredSection);
        break;
      case 'create':
        hasAccess = checkCreatePermission(requiredSection);
        break;
      case 'update':
        hasAccess = checkUpdatePermission(requiredSection);
        break;
      case 'delete':
        hasAccess = checkDeletePermission(requiredSection);
        break;
      default:
        hasAccess = checkViewPermission(requiredSection);
    }

    if (!hasAccess) {
      return fallback;
    }
  }

  // Check view permission for section if only section is provided
  if (requiredSection && !requiredAction) {
    if (!checkViewPermission(requiredSection)) {
      return fallback;
    }
  }

  return children;
};

export default PermissionGuard; 